import { Route } from '@angular/router';
import { inject } from '@angular/core';
import { RouteIds } from '../../../types';
import { CourseStepComponent } from './course-step.component';
import { StepResolverService } from '../../../services';

export const courseStepRoute: Route = {
  path: RouteIds.course,
  resolve: { step: () => inject(StepResolverService).resolve(RouteIds.course) },
  component: CourseStepComponent,
};
